import * as React from 'react';

import { DatabasesDisplayPlacePageData, TablesDisplayPlacePageData } from '@tableau/data-catalog-client-components';
import { ActionsMenu } from '../../../app/spaces/ActionsMenu/ActionsMenu';
import { mapGraphTypeToIContentAndLuidInfo } from '../../../ts/mappers/DatabaseAndTableMapper';

export function renderDatabasesActionMenu(database: DatabasesDisplayPlacePageData): JSX.Element {
  return <ActionsMenu targetItems={[mapGraphTypeToIContentAndLuidInfo(database)]} useIcon={true} />;
}

export function renderTablesActionMenu(table: TablesDisplayPlacePageData): JSX.Element {
  return <ActionsMenu targetItems={[mapGraphTypeToIContentAndLuidInfo(table)]} useIcon={true} />;
}
